module.exports = __webpack_public_path__ + "static/media/send-btn.ed2d7a25.svg";